var React = require('react');

function Apple (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M20.6 17.14c-.34.77-.74 1.48-1.21 2.13-.64.89-1.16 1.5-1.56 1.84-.63.56-1.3.85-2.01.87-.51 0-1.13-.15-1.86-.44a5.44 5.44 0 0 0-2-.43c-.63 0-1.31.15-2.05.43-.73.3-1.32.44-1.77.46-.69.03-1.37-.27-2.05-.89a13.06 13.06 0 0 1-3.36-5.25c-.49-1.37-.73-2.7-.73-4 0-1.47.33-2.74.98-3.8a5.68 5.68 0 0 1 4.83-2.8c.55 0 1.26.17 2.15.5.89.32 1.46.48 1.7.48.2 0 .82-.19 1.9-.57a6.39 6.39 0 0 1 2.56-.45 5.5 5.5 0 0 1 4.27 2.2c-1.7 1-2.53 2.4-2.52 4.2a4.6 4.6 0 0 0 1.57 3.5c.46.44.98.77 1.56 1-.13.36-.26.7-.4 1.02zM16.25.44c0 1.1-.41 2.13-1.23 3.08-1 1.13-2.2 1.78-3.5 1.68a4.76 4.76 0 0 1 1.28-3.53A5.22 5.22 0 0 1 16.23 0l.02.44z"}));
}

Apple.defaultProps = {"width":"24","height":"24","aria-label":"Apple","viewBox":"0 0 24 24"};

module.exports = Apple;

Apple.default = Apple;
